var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 bg-gray-100 mt-6",staticStyle:{"height":"38rem"}},[(_vm.boardPreview && _vm.isTabActive)?_c('iframe',{staticClass:"w-100 h-100 border-0",attrs:{"src":_vm.pdfBase64}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }